import type { IconProps } from '../types';

const LeftArrow = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="m11.608 24.497-7.273-7.273a1.143 1.143 0 0 1 0-1.616l7.273-7.273a1.143 1.143 0 0 1 1.616 1.616l-5.322 5.322H28v2.286H7.902l5.322 5.322a1.143 1.143 0 0 1-1.616 1.616z" />
  </svg>
);

export default LeftArrow;
